import React from 'react'
import { Typography } from '@mui/material'
import { K1Information } from '@e3dc-react/icons'
import { StyledContainer } from './styles'

interface Props {
  message: string
}

/**
 * Component to display an information message
 */
const InformationTile: React.FC<Props> = ({ message }) => {
  return (
    <StyledContainer>
      <K1Information />
      <Typography variant="body1">{message}</Typography>
    </StyledContainer>
  )
}

export default InformationTile
